import type { SandboxStatus } from "@app/lib/resources/storage/models/sandbox";
import { assertNever } from "@app/types/shared/utils/assert_never";
import { Chip } from "@dust-tt/sparkle";
import { useTranslation } from "react-i18next";

interface SandboxStatusChipProps {
  status: SandboxStatus;
}

export function SandboxStatusChip({ status }: SandboxStatusChipProps) {
  const { t } = useTranslation();

  switch (status) {
    case "running":
      return (
        <Chip
          size="mini"
          color="success"
          label={t("conv.sandboxComputerRunning", "Computer running")}
        />
      );
    case "sleeping":
      return (
        <Chip
          size="mini"
          color="warning"
          label={t("conv.sandboxComputerSleeping", "Computer sleeping")}
        />
      );
    case "pending_approval":
      return (
        <Chip
          size="mini"
          color="warning"
          label={t("conv.sandboxWaitingForApproval", "Waiting for approval")}
        />
      );
    case "deleted":
      return (
        <Chip
          size="mini"
          color="primary"
          label={t("conv.sandboxComputerExpired", "Computer expired")}
        />
      );
    default:
      assertNever(status);
  }
}
